<template>
  <div class="user-info">
    <ContentHeader />
    <div class="content-wrapper">
      <div class="content-title">
        {{ type === "create" ? "新建" : "编辑" }}账号
      </div>
      <div class="content-box">
        <div class="content-box__row">
          <el-form
            ref="userInfo"
            :rules="userRules"
            label-position="right"
            :model="userInfo"
            label-width="120px"
            label-suffix="："
          >
            <el-form-item label="供应商" prop="supplierCode">
              <el-input
                placeholder="请输入供应商编码"
                v-model="userInfo.supplierCode"
                clearable
                v-if="type === 'create'"
                style="width: 270px; height: 50px"
              ></el-input>
              <div v-else class="accountStyle">{{ userInfo.supplierCode }}</div>
              <el-button
                v-if="type === 'create'"
                type="danger"
                size="big"
                style="margin-left: 20px"
                @click="verifySupplierCode"
                >验证</el-button
              >
              <span
                class="supplierName"
                v-show="userList && userList.length !== 0"
                >{{ (userList[0] || {}).supplierName }}</span
              >
            </el-form-item>
            <el-form-item label="所属价格区域" prop="priceRegion">
              <el-select
                placeholder="请选择价格区域"
                style="width: 270px"
                @change="changePriceRegion"
                v-model="userInfo.priceRegion"
                :disabled="btnDisabled"
              >
                <el-option
                  v-for="item in priceRegionList"
                  :key="item.priceRegionId"
                  :label="item.priceRegionName"
                  :value="item.priceRegionId"
                />
              </el-select>
            </el-form-item>
            <el-divider></el-divider>
            <el-row type="flex" justify="start">
              <el-col :span="6">
                <el-form-item label="登录账号" prop="loginAccount">
                  <el-input
                    placeholder=" 请输入登录账号"
                    style="width: 270px; height: 50px"
                    v-model="userInfo.loginAccount"
                    v-if="!hasAccount"
                    maxlength="11"
                    :disabled="btnDisabled"
                  ></el-input>
                  <el-select
                    style="width: 270px"
                    @change="changeLoginAccount"
                    v-model="userInfo.loginAccount"
                    v-else
                    :disabled="btnDisabled"
                  >
                    <el-option
                      v-for="item in loginAccountList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.name"
                    ></el-option>
                  </el-select>
                  <div class="redColor" v-if="bccpermission">
                    该账号已有店招供应商权限，请切换或创建新账号
                  </div>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="loginAccountNumber">
                  <el-input
                    placeholder=" 请输入登录账号"
                    clearable
                    style="width: 270px; height: 50px; margin-left: 13px"
                    v-model="userInfo.loginAccountNumber"
                    v-if="userInfo.loginAccount === '创建新账号'"
                    maxlength="11"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="姓名" prop="userName">
              <el-input
                placeholder="请输入姓名"
                clearable
                style="width: 270px; height: 50px"
                v-model="userInfo.userName"
                :disabled="btnDisabled"
              ></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="workPhone">
              <el-input
                placeholder="请输入电话号码"
                clearable
                style="width: 270px; height: 50px"
                v-model="userInfo.workPhone"
                maxlength="11"
                :disabled="btnDisabled"
              ></el-input>
            </el-form-item>
            <el-divider></el-divider>

            <el-form-item label="权限" prop="assignBCCPermission">
              <el-checkbox
                v-model="userInfo.assignBCCPermission"
                :true-label="1"
                :false-label="0"
                >店招供应商</el-checkbox
              >
            </el-form-item>
          </el-form>
          <el-row
            class="content-row"
            style="margin-bottom: 10px"
            v-if="type === 'create' && createdPassword"
          >
            <el-col :span="21" class="changeColor">
              注：所有用户的初始密码都是 Abishopsign@2022
              请通知每位用户及时修改密码。
            </el-col>
          </el-row>
        </div>
        <div class="handle-foot">
          <el-button size="middle" @click="handleBtn('cancel')">关闭</el-button>
          <el-button
            size="middle"
            @click="handleBtn('create')"
            type="primary"
            :disabled="bccpermission"
            >{{ type === "edit" ? "保存" : "创建" }}</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
      <div class="hint">{{ saveMassage }}</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { localStorageUtils } from '@/utils/localstorage'
import ContentHeader from './components/content-header'
import formValidators from '@/utils/formValidators'
export default {
  name: 'user-info',

  components: {
    ContentHeader
  },
  data () {
    return {
      userRules: {
        supplierCode: [
          { required: true, message: '请输入供应商编码', trigger: 'blur' }
        ],
        userName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        workPhone: [
          { required: true, message: '请输入联系手机', trigger: 'blur' },
          {
            validator: formValidators.checkMobile,
            message: '请输入正确的手机号',
            trigger: 'blur'
          }
        ],
        loginAccountNumber: [
          {
            validator: this.checkRightLoginAccount,
            trigger: 'blur'
          }
        ],
        assignBCCPermission: [{ required: true }],
        priceRegion: [
          { required: true, message: '请选择价格区域', trigger: 'blur' }
        ],
        loginAccount: [{ required: true, message: '请输入登录账号' }]
      },
      dialogVisible: false,
      userInfo: {
        supplierCode: '',
        supplierId: '',
        supplier: '',
        priceRegion: '',
        priceRegionName: '',
        loginAccountNumber: '',
        loginAccount: '',
        userName: '',
        workPhone: '',
        assignBCCPermission: 1
      },
      operatingBtnType: '',
      priceRegionList: [],
      hasAccount: false,
      loginAccountList: [],
      userList: [],
      bccpermission: false,
      createdPassword: true,
      checkedRegion: '',
      btnDisabled: false
    }
  },
  computed: {
    type () {
      return this.$route.query.type
    },
    saveMassage () {
      const obj = {
        create:
          this.type === 'edit'
            ? '是否确定修改账号内容？'
            : '是否确定创建新账号？',
        cancel: '您还有信息未保存，是否确定关闭？',
        checkedRegion: `是否确定${
          this.checkedRegion ? '修改' : '所属'
        }价格区域为${this.userInfo.priceRegionName}？`
      }
      return obj[this.operatingBtnType]
    }
  },
  watch: {
    'userInfo.priceRegion' (val, oldVal) {
      console.log(oldVal, 'oldVal')
      this.checkedRegion = oldVal
    },
    type: {
      handler: function () {
        if (this.type === 'create') {
          this.btnDisabled = true
        }
      },
      immediate: true
    }
  },
  mounted () {
    this.getPriceRegion()
    if (this.type === 'create' && localStorageUtils.get('userInfo')) {
      localStorageUtils.remove('userInfo')
    }
    if (localStorageUtils.get('userInfo')) {
      this.userInfo = JSON.parse(localStorageUtils.get('userInfo'))
      if (this.userInfo.priceRegion) {
        this.checkedRegion = this.userInfo.priceRegion
      }
    }
  },
  methods: {
    // 取消 保存
    handleBtn (val) {
      if (val === 'cancel') {
        this.operatingBtnType = val
        this.dialogVisible = true
        return
      }
      // 保存校验
      this.$refs.userInfo.validate((valid) => {
        if (valid) {
          if (!this.userInfo.priceRegionName) {
            this.$message.error('请选择价格区域')
            return
          }
          this.operatingBtnType = val
          this.dialogVisible = true
        } else {
        }
      })
    },
    checkRightLoginAccount (rule, value, callback) {
      if (this.type === 'edit') callback()
      if (this.userInfo.loginAccount !== '创建新账号') callback()
      if (!value) callback(new Error('请输入登录账号'))
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (reg.test(value)) {
        callback()
      } else {
        callback(new Error('请输入手机号作为你的登录账号'))
      }
    },

    async verifySupplierCode () {
      this.userInfo.loginAccount = ''
      this.userInfo.workPhone = ''
      this.userInfo.userName = ''
      this.bccpermission = false

      if (this.userInfo.supplierCode === '') {
        this.$message.error('请输入供应商编码验证')
        return
      }
      const { data } = await this.$store.dispatch(
        'getSupplierAccount',
        this.userInfo.supplierCode
      )
      if (data.resultCode === '0') {
        this.btnDisabled = false
        const list = data.resultData?.userList || []
        this.hasAccount = !!list.length
        this.userList = [...list]
        this.userInfo.supplierId = data.resultData?.supplierId || []
        this.loginAccountList = list.map((item) => {
          const obj = {
            id: item.userId,
            name: item.loginAccount
          }
          return obj
        })
        if (this.loginAccountList.length > 0) {
          this.loginAccountList.push({ id: '01', name: '创建新账号' })
        }
        if (list.length && list[0].priceRegionName) {
          this.userInfo.priceRegionName = list[0].priceRegionName
          this.userInfo.priceRegion = list[0].priceRegion
        }
        return
      }
      this.btnDisabled = true
    },

    // 弹框取消
    handleCancel () {
      if (this.operatingBtnType === 'checkedRegion') {
        this.clearModify()
        return
      }
      this.dialogVisible = false
    },

    // 弹框确认
    async handleConfirm () {
      if (this.operatingBtnType === 'checkedRegion') {
        this.dialogVisible = false
        return
      }
      if (this.operatingBtnType === 'cancel') {
        this.$router.back()
        return
      }
      const userInfo = { ...this.userInfo }
      if (
        this.type === 'create' &&
        this.userInfo.loginAccount === '创建新账号'
      ) {
        userInfo.loginAccount = userInfo.loginAccountNumber
      }
      delete userInfo.loginAccountNumber
      const api =
        this.type === 'create'
          ? 'CreateSupplierBccAccount'
          : 'UpdateSupplierBccAccount'
      const message = this.type === 'create' ? '创建' : '修改'
      const { data } = await this.$store.dispatch(api, userInfo)
      this.dialogVisible = false
      if (data.resultCode === '0') {
        this.$router.push({
          path: '/bcc/user/list'
        })
        this.$message.success(`${message}账号成功`)
      }
    },

    changePriceRegion () {
      this.userInfo.priceRegionName = this.priceRegionList.find(
        (item) => item.priceRegionId === this.userInfo.priceRegion
      )?.priceRegionName
      this.operatingBtnType = 'checkedRegion'
      this.dialogVisible = true
    },
    async getPriceRegion () {
      const { data } = await this.$store.dispatch('getPriceRegion')
      if (data.resultCode === '0') {
        this.priceRegionList = data.resultData?.priceRegionList || []
      }
    },
    clearModify () {
      this.userInfo.priceRegion = this.checkedRegion
      this.userInfo.priceRegionName = this.priceRegionList.find(
        (item) => item.priceRegionId === this.checkedRegion
      )?.priceRegionName
      this.dialogVisible = false
    },
    changeLoginAccount () {
      const {priceRegionName, priceRegion} = this.userInfo
      this.userList.forEach((item) => {
        if (this.userInfo.loginAccount === item.loginAccount) {
          this.bccpermission = !!item.assignBCCPermission
          this.createdPassword = false
          this.userInfo = {
            ...item,
            priceRegionName,
            priceRegion,
            assignBCCPermission: 1
          }
        }
      })
      if (this.userInfo.loginAccount === '创建新账号') {
        this.bccpermission = false
        this.createdPassword = true
        this.userInfo.userName = ''
        this.userInfo.workPhone = ''
        this.userInfo.userId = ''
      }
      if (this.userInfo.loginAccount !== '创建新账号') {
        this.$refs.userInfo.clearValidate()
        this.createdPassword = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.content-header {
  height: 100px;
  background: url("../../../assets/images/banner-menu.jpg") center no-repeat;
  background-size: cover;
}
.content-title {
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 15px;
}
.content-box {
  border-radius: 10px;
  background-color: #fff;
  padding: 20px;
}
.changeColor {
  color: #cd1231;
}
.block-content {
  line-height: 30px;
  .content-row {
    margin-top: 15px;
  }
}
.handle-foot {
  width: 300px;
  margin: 40px auto;
  display: flex;
  justify-content: space-around;
}
::v-deep .el-dialog__header {
  border-bottom: 0px solid #dddddd;
}
::v-deep .el-dialog__footer {
  text-align: center;
  border-top: 0px solid #dddddd;
  padding-top: 16px;
}
::v-deep .el-dialog--center .el-dialog__body {
  text-align: center;
  padding: 25px 25px 30px;
  color: rgba(16, 16, 16, 100);
  font-size: 17px;
  font-family: "Microsoft Yahei";
}
.hint {
  text-align: center;
}
.accountStyle {
  left: 307px;
  top: 335px;
  width: 193px;
  height: 24px;
  color: rgba(176, 176, 176, 100);
  font-size: 16px;
  text-align: left;
  font-family: "SourceHanSansSC-regular";
}
.redColor {
  width: 278px;
  height: 17px;
  color: rgba(194, 20, 20, 100);
  font-size: 12px;
  text-align: left;
  font-family: "SourceHanSansSC-regular";
}
.supplierName {
  left: 659px;
  top: 336px;
  width: 96px;
  height: 24px;
  color: rgba(176, 176, 176, 100);
  font-size: 16px;
  text-align: left;
  font-family: "SourceHanSansSC-regular";
  margin-left: 20px;
}
.starPosition {
  // opacity: .6;
  position: absolute;
  left: -120px;
}
</style>

<style lang="scss">
.user-info {
  // 修改选择框颜色
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #918f8f !important;

    background-color: #409eff !important;
  }
  .el-checkbox__inner:hover {
    border-color: #918f8f !important;
  }
  .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #918f8f !important;
  }
  .el-checkbox {
    color: rgb(68, 65, 65);
  }
  // 修改选择label字体颜色
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: rgb(161, 157, 157) !important;
  }
}
</style>
